export default {
  tos: {
    en: `
<p>The Terms of Use (the "Terms") set forth the terms and conditions for the provision of the Service(the "Service") provided by Paike (the "Company"), and the rights and obligations between the Company and the registered Users(the "Users"). Users must agree to the Terms by reading the entirety before using the Service.</p>

<p>Article 1 Application</p>
<p>The Terms apply to all relationships between User and the Company related to the use of the Services. In addition to the Terms, individual terms of use and rules of use sent by the Company through e-mail website etc. shall also constitute an integral part of the Terms.</p>

<p>Article 2 Description of the Services.</p>
<p>
<ol>
<li>The primary goal of the Services is to be a platform that provides the matching service between any person whoever travels from abroad (the "Traveler")  and any person whoever lives or stays for a long time(the "Local"). The Company does not ensure that there is no possibility that a non-traveler may utilize the Services as a traveler, or a non-local person may utilize the Services as a Local.</li>
<li>The Services shall not be used for any purpose other than the international exchange intended by the Company, such as commercial purposes (including sales of goods, sending Users to specific services/stores, advertisements, etc.), recruitments of religions and specific organizations, and the sexual purpose.</li>
</ol>
</p>

<p>Article 3 Registration for use</p>
<p>
<ol>
<li>The Registration for use shall be completed when the person who applies for registration (“Registration Applicant”), having agreed to the Terms, applies for use of the Services and the Company approves thereof. If the Company determines that a Registration Applicant falls under or is likely to fall under any of the following, the Company may refuse, cancel or suspend the registration for use of the Registration Applicant. The Company does not take any liability for disclosure of the information.
<ol class="mb-3 list_parentheses">
<li>If the Registration Applicant declared any matter that is not true in User registration procedures;</li>
<li>If the Registration Applicant is a person whose the registration for the Services was refused, canceled or suspended in the past;</li>
<li>If the Company believes that the Registration Applicant is likely to violate the Terms;</li>
<li>When the Registration Applicant does not cooperate with the Company in providing feedback, etc. after using the Services;</li>
<li>If the Company determines that the Registration Applicant acts unpleasantly to any User, the Company Staff or third party in using the Services;</li>
<li>If the Company otherwise determines that registration of the Registration Applicant is not appropriate.</li>
</ol>
<li>Services shall only be available to any person aged 18 years of age or older. Registration by a representative is not permitted. </li>
<li>A person who belongs to or is related to anti-social forces such as organized crime groups may not register for the use of the Service. </li>
<li>The User may not transfer or lend the status based on the registration in paragraph 1 to a third party in any case.</li>
<li>In the event that a change is made to the items registered with the Company, the User must promptly notify the Company of the change by the method specified by the Company. The Company will not be liable for any disadvantage or damage to the User due to failure to submit a notification.</li>
<li>Completion of the Registration for Use under Paragraph 1 shall not guarantee the use of the Services.</li>
</li>
</ol>
</p>

<p>Article 4 Changes to the Terms of Use and Notices</p>
<p>
<ol>
<li>If the Company determines necessary, without obtaining the approval of Users, the Company may amend these Terms of Use.</li>
<li>If the Company amends these Terms of Use, a notice of material amendments will be given individually to Users who will be subject to such amendments, and a notice of other changes will be posted on the website of the Services. If after notice of such amendments, a User uses the Services or does not perform procedures to cancel the registration within a period prescribed by the Company, the User shall be deemed to have consented to the amendments to these Terms of Use.</li>
<li>The User shall be sure to check the Terms for each use of the Services. </li>
</ol>
</p>

<p>Article 5 Changes to Details of the Services;</p>
<p>
<ol>
<li>The Company may change the contents of the Services or discontinue the provision of the Services without notice to User.</li>
<li>The Company shall in no event be liable for any disadvantage or damage incurred by the User or any third party as a result of measures taken by the Company pursuant to the preceding paragraph.</li>
</ol>
</p>

<p>Article 6 Handling of Users &' Personal Information, etc.</p>
<p>The Company shall appropriately handle names, email addresses, and other personal information obtained from Users with regard to use of the Services, pursuant to these Terms of Use and the Privacy Policy separately stipulated by the Company.</p>

<p>Article 7 Consent to Provision of Personal Information to Third Parties</p>
<p>Users consent in advance to the Company's provision of User information to third parties with regard to the use of the Services pursuant to the Privacy Policy separately stipulated by the Company.</p>

<p>Article 8 Ownership of Intellectual Property Rights and Other Rights</p>
<p>
<ol>
<li>1 Ownership and Intellectual Property Rights (copyright, patent rights, utility model rights, design rights, trademark rights, and any other intellectual property rights.) in all photographs, data, illustrations, software, materials, designs, diagrams and other items pertaining to the Services, all other rights belong to the Company.</li>
<li>2 The license to use the Services under the User registration set forth in the Terms shall not be a license to use or use any intellectual property rights or any other rights owned or used by the Company.</li>
<li>3 The User shall not conduct any act which infringes or is likely to infringe intellectual property rights and any other rights held by the Company or a third party for any reason.</li>
<li>4 The User grants the Company a worldwide, non-exclusive, royalty-free, sub-licensable and transferable license to Use reproduce, distribute, prepare derivative works from, display and perform the photographs, illustrations, feedback (including answers to the questionnaire) and reports and other data the User may provide to the Company. The method of providing the information shall be irrespective of the form, such as sending by e-mail, uploading to the website operated by the Company and SNS managed by the Company.</li>
<li>5 The User agrees not to exercise the moral rights of the author against the Company or any person to whom the Company has succeeded or granted rights.</li>
</ol>
<p>

<p>Article 9 Prohibited Matters</p>
<p>
<ol>
<li>
When using the Services, Users may not directly or through a third party engage in any act that falls under, or that is likely to fall under, any of the following:
<ol class="mb-3 list_parentheses">
<li>Act of violating the Terms, rules established by the Company or instructions from the Company;</li>
<li>The act of providing the Company false information in relation to User registration information; </li>
<li>A criminal act, an act that is offensive to public order or morals or an act in violation of laws and regulations;</li>
<li>Act of using the Services for any purpose other than the international exchange  intended by the Company, such as commercial purpose (including sales of goods, sending Users to specific services/stores, advertisements, etc.), recruitments of religions and specific organizations, and the sexual purpose;</li>
<li>Act of using the Services for use of the Services for own or third party business/activities, regardless of profit or non-profit;</li>
<li>Act that cause discomfort to our staff, Users or third parties;</li>
<li>Any act that infringes on an intellectual property right, portrait right, privacy right, or any other right or interest of the Company, another User, or a third party;</li>
<li>The act of transmitting information that includes a computer virus or other harmful computer program;</li>
<li>Act of reporting or providing false or inaccurate information to the Company, the User or a third party in using the Services;</li>
<li>Any act that causes excessive load on the server of the Services, or any act that hinders the operation of the Services or on the network or system;</li>
<li>Act that hinders or might hinder our business or the operation of the Services</li>
<li>Act of using the Services or information or materials obtained through the Services for commercial purposes or other purposes unrelated to the Services;</li>
<li>Act of using the Services other than as permitted by the Company;</li>
<li>Any act that encourages or assists others to engage in illegal acts;</li>
<li>Any act that defames or damages trust in the Company, the staff or others;</li>
<li>The act of uploading photos and sentences that make others uncomfortable, uploading abusive photos and sentences;</li>
<li>Any act of behaving in a manner that makes others uncomfortable or in a abusive manner when using this service such as Chat between users;or</li>
<li>Any other act that the Company determines to be inappropriate.</li>
</ol>
</li>
<li>If the Company determines that any act of a User falls under any of the foregoing, without any notice to the User, the Company may delete all or a portion of registration information of such User.</li>
<li>The Company shall not be liable for any damage suffered as a result of the Company's response pursuant to the foregoing paragraphs.</li>
</ol>
</p>

<p>Article 10 Disclaimers and Indemnification</p>
<p>
<ol>
<li>The Company makes no warranties regarding matters such as the completeness, accuracy, usefulness, currency, and truthfulness of the information provided by the Services. The Company shall not be responsible for any results that arise from any act that a User carries out based on his/her judgment pursuant to the information provided by the Services.
<li>The Users shall use the Services on their own responsibility, and the Company shall not be liable for any matters relating to the Users in the Services.</li>
<li>If the Company is to bear liability for any reason, it shall not be liable for compensation for damage by the Company's negligence that exceeds the amount of the consideration for the related Contents. Further, the Company shall not be liable for incidental damage, indirect damage, special damage, future damage, or damage related to lost earnings and profits.</li>
<li>The User acknowledges that the Company and the Services only provide a place for matching between Users, and the matching itself as well as any transaction, dispute, etc. arising between Users or between Users and a third party after the matching shall be settled at their own expense between the parties and the Company shall have no responsibility.</li>
<li>With respect to the use of the Services by the User, if another User or other third party claims damages to the Company based on the intentional or negligence (including slight negligence) of the User. , The User is obliged to cooperate with us to resolve the case and to compensate for any damages and costs involved in the claim. </li>
</ol>
</p>

<p>Article 11 Temporary Suspension of Services</p>
<p>
<ol>
<li>
the Company may suspend the provision of Services without prior notice to User if:
<ol class="mb-3 list_parentheses">
<li>When performing maintenance on the Services and the systems and related equipment incidental thereto;</li>
<li>When the communication line, software service or electric power used by the Company becomes unavailable;</li>
<li>When a natural disaster such as earthquake, typhoon, flood, tsunami or any other emergency situation occurs, or because there is a likelihood of such an occurrence, there is a demand or instruction to restrict communication under laws, regulations, or directives;</li>
<li>Responding to laws and regulations, or guidance or requests from administrative authorities;</li>
<li>In the event that the number of subscriptions for the Services exceeds the capacity of the Company to respond to the Services;</li>
<li>When the provision of the Services becomes impossible due to other physical or technical reasons;</li>
</li>
</ol>
<li>Even if there is a delay or temporary suspension of the provision of the Services, the Company shall not be liable for damage suffered by a User or a third party from the same.</li>
</ol>
</p>

<p>Article 12 Withdrawal</p>
<p>If the User wishes to terminate the use of the Services or cancel the registration (the "Withdrawal"), the User shall declare to the Company in accordance with the method prescribed by the Company.</p>

<p>Article 13 Assignment</p>
<p>A User may not assign, transfer, provide as collateral, or dispose of, his/ her status under the service agreement or rights and duties under these Terms of Use without the prior written consent of the Company.</p>

<p>Article 14 Governing Law and Jurisdiction</p>
<p>
<ol>
<li>The Terms shall be governed by the laws of Japan.</li>
<li>In the event of any dispute arising in connection with the Services, regardless of dispute, the Tokyo District Court shall be the exclusive agreement jurisdictional court of the first instance.</li>
</ol>
<p>

<p>
*Legal notices<br />
Twemoji: Copyright 2020 Twitter, Inc and other contributors<br />
Code licensed under the MIT License: http://opensource.org/licenses/MIT<br />
Graphics licensed under CC-BY 4.0: https://creativecommons.org/licenses/by/4.0/<br />
</p>

<p style="text-align: right">
End<br />
Date of creation of Terms of Use<br />
[September 29, 2020]<br />
Revised [November 19, 2020]<br />
</p>
`,
    ja: `
<p>この利用規約（以下「本件規約」といいます。）は、株式会社Attic Start（以下「当社」といいます。）が、当社の提供するサービス（以下「本件サービス」といいます。）の利用条件・利用ルールを定めるものです。本件サービスをご利用されるユーザーの方々（以下「ユーザー」といいます。）におかれましては、必ず、本件規約を遵守し、本件サービスをご利用ください。本件規約に同意できない場合は、本件サービスの利用はいただけません。</p>

<p>第1条　適用</p>
<p>本件規約は、本件サービスの利用に関わるユーザーと当社との一切の関係に適用されます。本件規約に加えて、当社が電子メール・ウェブサイト等で発信する個別の利用条件・利用ルールも、本件規約の一部を構成します。</p>

<p>第２条　本件サービスの内容</p>
<p>
<ol>
<li>本件サービスは、海外からの旅行者（以下、本件サービスでは「旅行者」といいます。）と、その旅行者の旅先において活動または居住する人々（以下、本件サービスでは「ローカル」といいます。）をマッチングすることを主たる目的とするプラットフォームサービスです。但し、旅行者以外の者が旅行者として、またはローカル以外の者がローカルとして本件サービスを利用する可能性や旅行者同士・ローカル同士のマッチングに利用される可能性が排除されているものではありません。</li>
<li>本件サービスを、商業目的（物品販売、特定のサービス・店舗等への送客、宣伝などを含む）、宗教・特定の団体の勧誘目的、異性との交流目的等、当社が意図する国際交流以外の目的で使用することはできません。</li>
</ol>
</p>

<p>第３条　利用登録</p>
<p>
<ol>
<li>
ユーザーが、本件規約に同意の上、本件サービスの利用を申請し、当社がこれを承認することによって、利用登録が完了するものとします。但し、当社が次のいずれかの事由が存在する又は存在するおそれがあると判断した場合、ユーザーの利用登録について、拒否、取消、停止等の措置をとることがあります。当社の措置の理由について、当社は、一切の開示義務を負いません。
<ol class="mb-3 list_parentheses">
<li>利用登録の申請に際して、虚偽または不正確な事項を届け出た場合</li>
<li>過去に利用登録を拒否・取消・停止されたことがある場合</li>
<li>過去、現在を問わず、本件規約に違反した又は違反した可能性があると当社が判断した場合</li>
<li>本件サービス利用後に、フィードバックの提供等当社の求めに協力しない場合</li>
<li>本件サービスの利用にあたって他のユーザー、当社スタッフまたは第三者に不快感を与える言動をしたと当社が判断した場合</li>
<li>その他、当社が利用登録または利用継続を相当でないと判断した場合</li>
</ol>
</li>
<li>本件サービスを利用できる者は、満１８歳以上の自然人に限ります。また、代理人による登録はできません。</li>
<li>暴力団等の反社会的勢力に属する者または関係する者は、利用登録することはできません。</li>
<li>ユーザーは、いかなる場合にも、第１項の利用登録に基づく地位を、第三者に譲渡または貸与することはできません。</li>
<li>ユーザーは、当社への登録事項に変更が生じた場合は、当社所定の方法により、当社に対し、速やかに変更内容を届け出る必要があります。届出を行わなかったことにより、ユーザーが不利益または損害を被ったとしても、当社はその責任を一切負いません。</li>
<li>第１項の利用登録の完了は、本件サービスの利用を確約・保証するものではありません。</li>
</ol>
<p>

<p>第４条（利用規約の変更）</p>
<p>
<ol>
<li>
当社は以下の場合に、当社の裁量により、利用規約を変更することができます。
<ol class="mb-3 list_parentheses">
<li>利用規約の変更が、ユーザーの一般の利益に適合するとき</li>
<li>利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らし合理的なものであるとき</li>
</ol>
<li>当社は前項による利用規約の変更にあたり、変更後の利用規約の効力発生日の１週間前までに、利用規約を変更する旨及び変更後の利用規約の内容とその効力発生日を　　当社ウェブサイト（<a href="https://paikeout.com" target="_blank">https://paikeout.com</a>）に掲示し通知します。</li>
<li>本件サービスの利用毎に、本件規約を必ず、ご確認ください。</li>
</ol>
</p>

<p>第５条　本件サービス内容の変更等</p>
<p>
<ol>
<li>当社は、ユーザーに通知することなく、本件サービスの内容の変更または提供の中止をすることができるものとします。</li>
<li>前項の当社の措置によって、ユーザーまたは第三者に何らかの不利益または損害が生じたとしても、当社は、一切の責任を負いません。</li>
</ol>
</p>

<p>第６条　ユーザーの個人情報等の取り扱い</p>
<p>当社は、本件サービスの利用に際してユーザーから取得した氏名、メールアドレス等の個人情報等を、本件利用規約及び当社が別に定めるプライバシーポリシーに基づき、適切に取り扱うものとします。</p>

<p>第７条　個人情報等の第三者提供の同意</p>
<p>ユーザーは、本件サービスを利用するにあたって、当社が別途定めるプライバシーポリシーに基づきユーザーの個人情報等の情報が第三者に提供されることについて、あらかじめ同意するものとします。</p>

<p>第８条　知的財産権等の権利帰属等</p>
<p>
<ol>
<li>本件サービスにかかるすべての写真、データ、イラスト、ソフトウェア、資料、デザイン、図表等に関する所有権及び知的財産権（著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権を意味します。）、その他一切の権利は、当社に帰属します。</li>
<li>本件規約に定めるユーザー登録に基づく本件サービスの利用許諾は、当社の保有・使用する知的財産権その他一切の権利について、使用または利用を許諾するものではありません。</li>
<li>ユーザーは、いかなる理由によっても、当社または第三者の保有する知的財産権その他一切の権利を侵害し、または侵害するおそれのある行為をしてはいけません。</li>
<li>ユーザーは、ユーザーが当社に提供する写真、イラスト、フィードバック（アンケートへの回答を含む）及びレポートその他のデータについて、当社に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用、複製、配布、派生著作物の作成、表示及び実行に関するライセンスを付与します。その提供方法は、Eメールでの送信、当社が運営するウェブサイト及び当社が管理するSNSへのアップロード等、その態様を問わないものとします。</li>
<li>ユーザーは、当社及び当社から権利を承継または許諾された者に対して著作者人格権を行使しないことに同意するものとします。</li>
</ol>
</p>

<p>第９条　禁止事項</p>
<p>
<ol>
<li>
本件サービスの利用にあたって、ユーザーが、自己または第三者を利用して、次のいずれかに該当する行為、またはそのおそれのある行為をすることは禁止されています。
<ol class="mb-3 list_parentheses">
<li>本件規約、当社が定めたルール、当社からの指示等に違反する行為　</li>
<li>利用登録にあたって、虚偽または不正確な情報を申告・提供する行為</li>
<li>犯罪行為、公序良俗に反する行為、法令違反行為</li>
<li>本件サービスを、商業目的（物品販売、特定のサービス・店舗等への送客、店舗からのキックバック、宣伝などを含む）、宗教・特定の団体の勧誘目的、異性との交流目的等、当社が意図する国際交流以外の目的で使用する行為</li>
<li>営利・非営利を問わず、本件サービスを自己又は第三者の事業・活動に利用する行為</li>
<li>当社スタッフ、ユーザーまたは第三者に不快感を与える言動</li>
<li>当社、ユーザー、その他第三者の知的所有権、肖像権、プライバシー権およびその他の権利や利益を侵害する、または侵害するおそれのある行為</li>
<li>コンピューターウィルス等有害なコンピュータープログラムを含むデータ・情報を伝達、拡散、組み込む等の行為</li>
<li>本件サービスの利用にあたって、当社、ユーザーまたは第三者に虚偽または不正確な情報を申告・提供等する行為</li>
<li>通常の範囲を超えて本件サービスのサーバーに負担を及ぼす等、本件サービスの運営に支障をきたす行為</li>
<li>当社の業務または本件サービスの運営を妨げるまたは妨げるおそれのある行為</li>
<li>本件サービスまたは本サービスを利用する過程で入手した情報もしくは資料を、本サービスと無関係な目的で利用する行為</li>
<li>当社が許容する以外の方法で本件サービスを利用する行為</li>
<li>ユーザーまたは第三者に本条に定める禁止行為を勧誘または助長する行為</li>
<li>当社、当社スタッフ、ユーザーまたは本件サービスの信用・信頼を失墜・毀損させる行為またはそのおそれのある行為</li>
<li>他人を不快にする写真や文章、虐待的な写真や文章などをアップロードする行為</li>
<li>ユーザー同士のChatなど本件サービスの使用にあたって、相手を不快にする言動、虐待的な言動を行うこと</li>
<li>その他、当社が不適切と判断する行為</li>
</ol>
</li>
<li>当社は、ユーザーの行為が前項のいずれかに該当するまたは該当するおそれがあると判断した場合、ユーザーへの事前の通知なく、利用登録の抹消、本件サービスの利用停止等の措置を講じることができるものとします。</li>
<li>当社は、当社の前項の措置に基づいてユーザーまたは第三者に何らかの不利益または損害が生じたとしても、一切の責任を負いません。</li>
</ol>
</p>

<p>第１０条　免責等</p>
<p>
<ol>
<li>当社は、本件サービスがユーザーの特定の目的に適合すること、及び期待する機能、価値、正確性、有用性を有すること、ユーザーによる本件サービスの利用がユーザーに適用のある法令又は規則等に適合すること、本件サービスが継続的に利用できること、及び不具合が生じないこと、並びに本件サービスにより提供される情報及びユーザーに関する情報の完全性、正確性、真実性等については、明示又は黙示を問わず、何ら確約・保証するものではありません。</li>
<li>ユーザーは自らの責任に基づいて本件サービスを利用するものとし、当社は本件サービスにおけるユーザーに関する一切の事項について、何らの責任を負いません。</li>
<li>当社が何らかの事由によって責任を負う場合であっても、関連するコンテンツの対価の相当額を超えて損害を賠償する責任を負いません。また、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないこととします。</li>
<li>ユーザーは、当社及び本件サービスが、ユーザー同士のマッチングの場を提供するのみに留まることを確認し、マッチングそれ自体及びマッチング以降にユーザー間またはユーザーと第三者間に生じるいかなる取引、紛争等について、当事者間で各自の負担をもって解決するものとし、当社は一切の責任を負わないものとします。</li>
<li>ユーザーによる本件サービスの利用等に関して、当該ユーザーの故意・過失（軽過失を含みます。）に基づき、他のユーザーその他の第三者から、当社に対して損害の賠償請求があった場合、当該ユーザーは当社に対して事案解決のために協力する義務を負うとともに、当該請求にかかる一切の損害及び費用につき、補償する義務があります。</li>
</ol>
</p>

<p>第１１条　本件サービスの一時的な中断</p>
<p>
<ol>
<li>
当社は、次のいずれかの事由に該当する場合、ユーザーに事前に通知することなく、本件サービスの提供を中断することがあります。
<ol class="mb-3 list_parentheses">
<li>本件サービス及びそれに付随するシステム・関連設備等の保守メンテナンスを実施する場合</li>
<li>当社が利用する通信回線、ソフトウェアサービス、電力等の利用・供給ができなくなった場合</li>
<li>火災、停電、地震、台風、洪水、津波等の天災その他の非常事態が発生した場合、またはそのおそれが生じた場合</li>
<li>法令上の対応、行政官庁等の指導・要請に基づく対応を行う場合</li>
<li>本件サービスの利用登録数が当社の本件サービスの対応能力を超える場合</li>
<li>その他、物理的・技術的な事由により本サービスの提供ができなくなったとき</li>
</ol>
</li>
<li>当社は、本件サービスの提供が遅滞、中断した場合、その提供が不完全な場合でも、これらに起因してユーザーまたは第三者が被った一切の不利益または損害について、一切責任を負わないものとします。</li>
</ol>
</p>

<p>第１２条　退会</p>
<p>ユーザーは、本件サービスの利用を終了、または登録を抹消したい場合（以下「退会」といいます。）は、当社所定の方法に従って、当社に対し申告するものとします。</p>

<p>第１３条　譲渡</p>
<p>ユーザーは、当社の書面による事前の承諾なく、本件規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。</p>

<p>第１４条 準拠法と裁判管轄</p>
<p>
<ol>
<li>本件規約の準拠法は日本法とします。</li>
<li>本件サービスに関連して紛争が生じた場合には、紛争の如何に拘わらず、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
</ol>
</p>

<p>
*補足<br />
Twemoji: Copyright 2020 Twitter, Inc and other contributors<br />
Code licensed under the MIT License: http://opensource.org/licenses/MIT<br />
Graphics licensed under CC-BY 4.0: https://creativecommons.org/licenses/by/4.0/<br />
</p>

<p style="text-align: right;">
以上
</p>
<p>
作成日 2020年9月29日<br />
変更日 2020年11月19日<br />
</p>
`,
  },
  pp: {
    en: `
<p>Attic Start Co., Ltd. (the "Company") sets forth the Privacy Policy (the "Policy") with regard to the treatment of user information(Article 2, Paragraph 1 of the Act on the Protection of Personal Information), including but not limited to personal information, in the course of the performance of Service provided by the Company (the “Service"),as follows; Please read the Policy before using the Services. In order to use the Services, the User must agree to the terms of the Policy; otherwise, the User may not use the Services. Please refer to the Terms for definitions of terms in the Policy.</p>

<p>1 User information to be collected and the method of collection</p>
<p>“User Information” in the Policy means information related to customer identification, a customer’s action history on communication services, and other information related to customers or the Users terminals generated or stored on customer’s smartphones, personal computers, or other terminals that the Company collects pursuant to the Policy. User information that The Company collects in the Services, depending on the method of collection, shall be as follows.<p>

<p>(1) Information provided by the user</p>
<p>In order to use the Services, the User will provide us with the following information.</p>
<p>
<ul>
<li>Name, country of origin, a region of residence, telephone number, e-mail address, date of birth, sex, photo</li>
<li>Place of departure, destination, duration of the trip and area of availability</li>
<li>Interest/the thing what the User like, language, language level, self-introduction</li>
<li>Feedback, comments, and reviews relevant to the use of the Services;</li>
<li>Other information the Users enter in registration forms provided by The Company</li>
</ul>
</p>

<p>(2) Information that, when a customer permits linkage with other services in using the Services, is provided by such other services</p>
<p>If when using the Services, a customer permits linkage with social network services and other external services, the Company may collect information provided by external services with which linkage has been permitted. Such information includes the following:</p>
<p>
<ul>
<li>IDs and other identification information that a customer uses on such external services</li>
<li>Other information that a customer permits on the privacy settings of such external services disclosure to linkage partners</li>
</ul>
</p>

<p>(3) Information automatically collected by the Company in the course of the user's use of the ServiceThe Company may collect information regarding access to or use of the Service, which includes the following.</p>
<p>
<ul>
<li>Device information</li>
<li>Information regarding server access logs</li>
<li>Identifying information generated using cookie technology</li>
<li>Location information</li>
<li>IP Address</li>
<li>Chat with other Users </li>
</ul>
</p>

<p>2 Purpose of Use</p>
<p>Collected usage information is used for the following purposes.</p>
<p>(1) Provision, improvement and development of the Services</p>
<p>
<ul>
<li>To provide the Services, register for use, and confirm the identity</li>
<li>To be used for matching with other users (the Traveler or the Local)</li>
<li>To maintain, protect and maintain the Services and improve the quality of the Services　</li>
<li>To provide the Services safely (finding users who violate the Terms of Service and notifying them, and investigating, detecting and preventing misconduct such as misuse, fraud and unauthorized access of the Services)　</li>
<li>To develop new services and functions</li>
<li>To maintain the system and respond to problems</li>
<li>To conduct a questionnaire</li>
<li>To respond to guidance, inquiries, etc. concerning the Services;</li>
<li>To notify customers of information on promotions, after-sale services, and new products and services relating to the Services;</li>
<li>To distribute information (including advertisements, etc.) regarding third parties related to the Service</li>
<li>To notify the User of changes in the terms of the Services, etc.</li>
<li>To discover, prevent, and respond to fraud, abuse, abuse, spam, and other harmful acts or acts that violate the Terms of Service</li>
<li>Any other purposes incidental to the above-mentioned purposes of use; or</li>
</ul>
</p>

<p>(2) Develop services based on advertising, marketing and data analysis
<p>The Company may use and analyze the collected information to create statistical data processed in a format that cannot identify individuals for marketing, consulting, advertisement display, advertisement distribution, etc.</p>
<p>Information that is processed and used in a format that cannot identify individuals is as follows.</p>
<p>
<ul>
<li>Device information</li>
<li>Information regarding server access logs</li>
<li>Identifying information generated using cookie technology</li>
<li>Location information</li>
<li>IP Address</li>
<li>Language of Use.</li>
<li>National origin</li>
<li>Residential area</li>
<li>Age, Date of Birth</li>
<li>Gender</li>
<li>Chat with other Users </li>
<li>Feedback, Feedback, and Reviews</li>
<li>Other information the User registers in The Company’s registration form, inquiry form or other forms.</li>
</ul>
</p>

<p>3.Method of requesting discontinuation of use</p>
<p>By performing the prescribed settings for the Services, the User may request discontinuation of use of all or part of his/her User Information; in such a case, in accordance with the Company’s stipulations, the Company will promptly discontinue such use. Depending on the type of User Information, the collection or use of such information may be a condition to the Services, and in such a case, if and only if the User cancels the Services in a manner prescribed by the Company, the Company will discontinue such collection.</p>

<p>4.Consent to the provision of User Information to third parties</p>
<p>Before using the Services, a customer must consent to the provision of User Information by the Company to third parties as set forth below.</p>
<p>User 's ID, nickname, photograph, sex, age-based generation, place of travel, a region of residence, country of origin, a region of activity, interest, the things the User likes, language used, language learning level, self-introduction, past usage history of the Services, and any other information permitted by the User;</p>

<p>5 Provision of personal information to third parties</p>
<p>Without obtaining prior consent under the preceding paragraph, unless permitted under the Personal Information Protection Act or other laws and regulations, the Company will not provide any User Information that is personal information to third parties without obtaining the prior consent of the User; provided, however, that the following will not apply in the following cases:</p>
<p>(1) If the Company the outsources the handling of personal information in whole or in part within the scope necessary to realize the use purposes;</p>
<p>(2) If personal information is provided in conjunction with a merger or other business succession;</p>
<p>(3)If, in a case where it is necessary to cooperate with a government agency, local public agency, or a person entrusted by either of the foregoing in the carrying out of work stipulated under laws and regulations, the act of obtaining the consent of the User is likely to hinder such work; or</p>
<p>(4) If otherwise permitted under the Personal Information Protection Act or other laws and regulations</p>

<p>6.Safety management for protection of personal information</p>
<p>The Company will stipulate rules to protect the personal information it acquires, publicize and emphasize such rules to its employees, and work towards maintaining and enhancing safety management measures necessary to protect the personal information acquired by the Company.</p>

<p>7.Disclosure of personal information</p>
<p>If a customer requests disclosure of personal information pursuant to the stipulations of the Personal Information Protection Act, after confirming that such request is from the User himself/herself or a legitimate agent (presentation of personal identification documents may be requested), the Company will make the disclosure to the User without delay (if the relevant personal information does not exist, the User will be notified to that effect); provided, however, that the foregoing will not apply in cases where the Company is not obligated to make disclosure under the Personal Information Protection Act or other laws and regulations. It should be noted in advance that there will be a fee (500 yen per request) for the disclosure of personal information.</p>

<p>8.Correcting and discontinuing use etc. of personal information</p>
<p>(1) Correction and suspension of the use of personal information</p>
<p>If (i) on the grounds that personal information is not true, a customer requests the correction of the content of such information pursuant to the Personal Information Protection Act, or (ii) on the grounds that personal information is being handled beyond the scope of use purposes announced in advance or that personal information was obtained through deceit or other unauthorized means, a customer requests discontinuation of use of personal information pursuant to the Personal Information Protection Act, or (ⅲ) on the grounds that personal information is provided to third parties in contravention of Restriction on Third Party Provision of the Personal Information Protection Act, a customer requests discontinuation of the provision to third parties, after confirming that the request is from the User himself/herself, the Company will perform the necessary investigation without delay, and on the basis of the findings of such investigation, correct the content of, discontinue the use of personal information or discontinue the provision to third parties, and notify the User to that effect. If the Company decides not to correct, discontinue use or discontinue the provision to third parties based on a valid reason, the User will be notified to that effect.</p>
<p>(2) Deletion of personal information</p>
<p>If a customer requests removal of his/her personal information, and the Company determines that it is necessary to comply with such request, after confirming that the request is from the User himself/herself, the Company will remove the personal information, and notify the User to that effect.</p>
<p>(3) Exemption</p>
<p>If under the Personal Information Protection Act or other laws and regulations, the Company is not obligated to carry out correction etc. or discontinuation of use etc., the preceding two paragraphs will not apply.</p>

<p>9.Contact point for inquiries</p>
<p>Opinions, questions, complaints, and other inquiries concerning the handling of User Information should be addressed to the following:</p>

<p>
2-5-3 Nagatacho GRID 5F Midori.so, Hirakawa-cho, Chiyoda-ku, Tokyo 〒102-0093<br />
Attic Start Customer Support Center (Manager: Keisuke Tomida)<br />
E-mail: <a href="mailto:support@paikeout.com">support@paikeout.com</a><br />
</p>

<p>10.Procedures to amend the Policy</p>
<p>The Company will perform appropriate reviews of the state of operations relating to the handling of User Information, work towards continuous improvement, and may amend the Policy when necessary. If the Policy is amended, customers will be notified by posting on the Company’s webpage; provided, however, that for amendments that require the consent of customers under laws and regulations, the consent of customers will be obtained by methods prescribed by the Company.</p>

<p style="text-align: right;">End</p>
`,
    ja: `
<p>株式会社Attic Start（以下「当社」といいます。）は、当社の提供するサービス（以下「本件サービス」といいます。）におけるユーザーの個人情報（個人情報保護法第２条第１項の定義によります。）を含む利用者情報の取り扱いについて、プライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>
<p>本件サービスをご利用になる前に、必ず、本ポリシーをご一読ください。本件サービスのご利用にあたっては、本ポリシーの記載事項についての同意が必要であり、ご同意いただけない場合は、本件サービスをご利用いただけません。尚、本ポリシー中の語句の定義については、本件規約をご参照ください。</p>

<p>１　収集する利用者情報及び収集方法</p>
<p>本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーのスマートフォン、ＰＣ等の端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味します。</p>
<p>本件サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。</p>

<p>(1)　ユーザーから提供される情報</p>
<p>ユーザーが本件サービスを利用するために、以下の情報を提供していただくことになります。</p>
<p>
<ul>
<li>氏名、出身国、居住地域、電話番号、メールアドレス、生年月日、性別、写真</li>
<li>旅行出発地、旅行先、旅行期間、行動可能地域</li>
<li>興味/関心、好きなもの、使用言語、語学の習得レベル、自己紹介文</li>
<li>本件サービス利用に伴うフィードバック、感想、レビュー</li>
<li>その他当社が定める登録フォームにユーザーが入力する情報</li>
</ul>
</p>

<p>(2)　ユーザーが本件サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスから提供される情報</p>
<p>ユーザーが、本件サービスを利用するにあたり、ソーシャルネットワークサービス等の外部サービスとの連携を許可した場合には、その許可の際にユーザーが同意した内容に基づき、以下の情報を当該外部サービスから収集する場合があります。</p>
<p>
<ul>
<li>当該外部サービスでユーザーが利用するＩＤ等の識別情報</li>
<li>その他当該外部サービスのプライバシー設定によりユーザーが連携先に開示を認めた情報</li>
</ul>
</p>

<p>(3)　ユーザーが本件サービスを利用するにあたって、当社が収集する情報</p>
<p>当社は、本件サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。</p>
<p>
<ul>
<li>端末情報</li>
<li>ログ情報</li>
<li>Cookie技術を用いて生成された識別情報</li>
<li>位置情報</li>
<li>IPアドレス</li>
<li>チャットでのユーザー同士のやり取り</li>
</ul>
</p>

<p>２　利用目的</p>
<p>収集した利用情報は、以下の目的に使用します。</p>

<p>(1)　本件サービスの提供、改善及び開発</p>
<p>
<ul>
<li>本件サービスの提供、利用登録、本人確認等のため</li>
<li>他のユーザー（旅行者またはローカル）とのマッチングに使用するため</li>
<li>本件サービスの維持、保護、メンテナンス及び本件サービスの品質の向上のため</li>
<li>本件サービスを安全に提供するため（利用規約に違反しているユーザーを発見して当該ユーザーに通知をすること、本件サービスの悪用、詐欺、不正アクセス等の不正行為を調査、検出、予防すること等の対応が含まれます。）</li>
<li>新たなサービス、新機能の開発のため</li>
<li>システムの維持、不具合等への対応のため</li>
<li>アンケートの実施のため</li>
<li>本件サービスに関する案内、お問い合わせ等への対応のため</li>
<li>本件サービスに関連するプロモーション、アフターサービス、新商品・新サービスに関する情報のお知らせのため</li>
<li>本件サービスと関連する第三者に関する情報（広告等を含みます。）を配信等するため</li>
<li>本件サービスに関する規約等の変更などを通知するため</li>
<li>詐欺、悪用、不正使用、スパム等の有害行為または利用規約に違反する行為の発見、防止、対応のため</li>
<li>上記の利用目的に付随する利用目的のため</li>
</ul>
</p>

<p>(2)　広告、マーケティングおよびデータ解析に基づくサービスの開発</p>
<p>収集した情報は、個人を識別できない形式に加工した統計データを作成し、マーケティング、コンサルティング、広告表示、広告配信等の目的で、当該統計データを解析し、利用することがあります。尚、個人を識別できない形式に加工して利用する情報は、以下のとおりです。</p>
<p>
<ul>
<li>端末情報</li>
<li>ログ情報</li>
<li>Cookie及びCookie技術を用いて生成された情報</li>
<li>位置情報</li>
<li>IPアドレス</li>
<li>利用言語</li>
<li>出身国</li>
<li>居住地域</li>
<li>年齢、生年月日</li>
<li>性別</li>
<li>メール、チャット等のやりとりの内容</li>
<li>フィードバック、感想、レビュー</li>
<li>その他当社の登録フォームやお問い合わせフォーム等にユーザーが登録する情報</li>
</ul>
</p>

<p>３　利用中止要請の方法</p>
<p>ユーザーは、当社所定の方法により、利用者情報の全部または一部についてその利用の停止を求めることができ、この場合、当社は速やかに、当社の定めるところに従い、その利用を停止します。なお、利用者情報の項目によっては、その収集または利用が本件サービスの前提となるため、当社所定の方法により本件サービスを退会した場合に限り、当社はその収集を停止します。</p>

<p>４　利用者情報の第三者提供に関する同意等</p>
<p>ユーザーには、本件サービスを利用するに際して、以下の利用者情報について、当社から第三者に対し、利用者情報が提供されることについて、あらかじめ同意するものとします。</p>
<p>ユーザーのＩＤ、ニックネーム、写真、性別、年齢に基づく世代、旅行出発地、居住地域、出身国、行動可能地域、興味／関心、好きなもの、使用言語、語学の習得レベル、自己紹介文、過去の本件サービスの利用履歴、その他ユーザーが許諾した情報</p>

<p>５　個人情報の第三者への提供</p>
<p>当社は、利用者情報のうち、個人情報について、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめユーザーの同意を得ないで、第三者に提供しません。但し、次に掲げる場合はこの限りではありません。</p>
<p>(1)　当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合（広告配信、データ分析、マーケティング等）</p>
<p>(2)　合併その他の事由による事業の承継に伴って個人情報が提供される場合</p>
<p>(3)　国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合</p>
<p>(4)　その他、個人情報保護法その他の法令で認められる場合</p>

<p>６　個人情報保護のための安全管理</p>
<p>当社は、当社が取得した個人情報の漏洩防止、安全管理等のために、当社が取得した個人情報を保護するための規定等を定め、従業員に周知・徹底する等、必要な安全管理措置の維持・向上に努めます。但し、これらの安全管理措置は、個人情報の漏洩等が起こり得ないことを保証するものではありません。当社の適切な運用にも拘わらず、第三者の不正行為等により生じた事故等について当社は一切責任を負いません。</p>

<p>７　個人情報の開示</p>
<p>当社は、ユーザーから、個人情報保護法の定めに基づき個人情報の開示を求められたときは、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、ユーザーに対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり５００円）及び実費を請求させていただきます。</p>

<p>８　個人情報の訂正及び利用停止等</p>
<p>(1)　個人情報の訂正及び利用停止</p>
<p>当社は、ユーザーから、①個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び②あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合、③ユーザーに関する保有個人データが第三者提供の制限に関する個人情報保護法の定めに違反して第三者に提供されているという理由によって、第三者への提供の停止を求められた場合には、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正、利用停止、または第三者への提供の停止を行い、その旨をユーザーに通知します。なお、合理的な理由に基づいて訂正、利用停止、または第三者への提供の停止を行わない旨の決定をしたときは、ユーザーに対してその旨を通知いたします。</p>
<p>(2)　個人情報の消去</p>
<p>当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、個人情報の消去を行い、その旨をユーザーに通知します。</p>
<p>(3)　適用除外</p>
<p>個人情報保護法その他の法令により、当社が訂正等又は利用停止等の義務を負わない場合は、前2項の規定は適用されません。</p>

<p>９　お問い合わせ窓口</p>
<p>ご意見、ご質問、苦情のお申出その他利用者情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。</p>

<p>
住所：〒102-0093 東京都千代田区平河町2-5-3 Nagatacho GRID 5F Midori.so<br />
株式会社Attic Start カスタマーサポートセンター（担当：Keisuke Tomida）<br />
E-mail：<a href="mailto:support@paikeout.com">support@paikeout.com</a><br />
</p>

<p>１０　本ポリシーの変更手続</p>
<p>当社は、利用者情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本ポリシーを変更することがあります。変更した場合には、当社所定の方法でユーザーに通知いたします。改定後に本件サービスを利用した場合、変更後のポリシーに同意されたものとみなされます。但し、法令上ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法でユーザーの同意を得るものとします。</p>

<p style="text-align: right;">以上</p>

<p>作成日 2020年9月29日</p>
`,
  },
}